import api from './api';

class LeaveService {
  /**
   * Apply for leave
   * @param {Object} leaveData - Leave request data
   * @returns {Promise<Object>} API response
   */
  static async applyForLeave(leaveData) {
    try {
      const response = await api.post('/leave/apply', leaveData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  /**
   * Get my leave requests
   * @param {Object} filters - Optional filters
   * @returns {Promise<Object>} API response
   */
  static async getMyLeaves(filters = {}) {
    try {
      const params = new URLSearchParams();
      if (filters.status) params.append('status', filters.status);
      if (filters.startDate) params.append('startDate', filters.startDate);
      if (filters.endDate) params.append('endDate', filters.endDate);

      const response = await api.get(`/leave/my-leaves?${params.toString()}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  /**
   * Get all leave requests (HRO only)
   * @param {Object} filters - Optional filters
   * @returns {Promise<Object>} API response
   */
  static async getAllLeaves(filters = {}) {
    try {
      const params = new URLSearchParams();
      if (filters.status) params.append('status', filters.status);
      if (filters.startDate) params.append('startDate', filters.startDate);
      if (filters.endDate) params.append('endDate', filters.endDate);
      if (filters.userId) params.append('userId', filters.userId);

      const response = await api.get(`/leave/all?${params.toString()}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  /**
   * Approve leave request
   * @param {string} leaveId - Leave request ID
   * @returns {Promise<Object>} API response
   */
  static async approveLeave(leaveId) {
    try {
      const response = await api.patch(`/leave/approve/${leaveId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  /**
   * Reject leave request
   * @param {string} leaveId - Leave request ID
   * @param {string} rejectionReason - Reason for rejection
   * @returns {Promise<Object>} API response
   */
  static async rejectLeave(leaveId, rejectionReason) {
    try {
      const response = await api.patch(`/leave/reject/${leaveId}`, {
        rejectionReason
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  /**
   * Get leave statistics
   * @returns {Promise<Object>} API response
   */
  static async getLeaveStats() {
    try {
      const response = await api.get('/leave/stats');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
}

export default LeaveService;